export default __webpack_public_path__ + "static/media/logo_safefleet.bc515a84.png";